import { render, staticRenderFns } from "./ednMimic.vue?vue&type=template&id=484b0d48&"
import script from "./ednMimic.vue?vue&type=script&lang=js&"
export * from "./ednMimic.vue?vue&type=script&lang=js&"
import style0 from "./ednMimic.vue?vue&type=style&index=0&id=484b0d48&prod&lang=scss&"


/* normalize component */
import normalizer from "!./node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports